var exports = {
  "_J": "xfd349460--e4a313--nav_container" + " " + __webpack_require__(33767)["sectorWithSticky"],
  "wx": "xfd349460--e4a313--header",
  "aw": "xfd349460--e4a313--slider",
  "kL": "xfd349460--e4a313--container",
};

module.exports = exports;
